export const notePrivacyOptions: { label: string; value: string }[] = [
  { label: 'Private - Visible to Groundfloor only', value: 'private' },
  { label: 'Public - Visible to anyone who can see the delivery', value: 'public' }
];
